import { render, staticRenderFns } from "./RulesCheckbox.vue?vue&type=template&id=0cf2a66a&scoped=true"
import script from "./RulesCheckbox.vue?vue&type=script&lang=ts"
export * from "./RulesCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2a66a",
  null
  
)

export default component.exports